export function cmpOptimizelyBridge() {
  "use strict";

  //===============
  //   Constants
  //===============

  // CookiePro "Performance/Analytics" category ID
  const ANALYTICS_CAT = "C0002";

  //===============
  //   Functions
  //===============

  // Check if user has granted analytics consent via CookiePro
  const hasAnalyticsConsent = () => {
    try {
      if (!window.OnetrustActiveGroups) {
        return false;
      }

      const groups = window.OnetrustActiveGroups;
      return groups.includes(ANALYTICS_CAT);
    } catch {
      return false;
    }
  };

  // Hold Optimizely events until consent is determined
  const holdEvents = () => {
    try {
      window.optimizely?.push({ type: "holdEvents" });
    } catch (error) {
      console.error("[Optimizely] Failed to hold events:", error);
    }
  };

  // Release events with appropriate consent settings
  const releaseEvents = () => {
    try {
      window.optimizely = window.optimizely || undefined;

      if (!window.optimizely) {
        throw new Error("Optimizely object not found on window.");
      }

      const hasConsent = hasAnalyticsConsent();
      window.optimizely.push({ type: "setOptOut", isOptOut: !hasConsent });

      if (hasConsent) {
        window.optimizely.push({ type: "sendEvents" });
        document.dispatchEvent(new Event("optly:consent-ready"));
      } else {
        holdEvents();
      }

      // Store current consent state
    } catch (error) {
      console.error("[Optimizely] Failed to release events:", error);
    }
  };

  const waitForOneTrust = () => {
    // Check if OneTrust is already loaded
    if (window.OnetrustActiveGroups) {
      releaseEvents();
      return;
    }

    let isResolved = false;

    // Fallback: Poll for OnetrustActiveGroups (in case event doesn't fire)
    let attempts = 0;
    const maxAttempts = 50; // 5 seconds max
    const pollInterval = setInterval(() => {
      attempts++;

      if (window.OnetrustActiveGroups) {
        if (!isResolved) {
          isResolved = true;
          clearInterval(pollInterval);
          releaseEvents();
        }
      } else if (attempts >= maxAttempts) {
        if (!isResolved) {
          isResolved = true;
          console.warn(
            "[Optimizely] OneTrust timeout - proceeding without consent",
          );
          clearInterval(pollInterval);
          releaseEvents();
        }
      }
    }, 100);

    // Option 1: Use OneTrust's consent event (fires when consent data is ready)
    const onConsentReady = () => {
      if (!isResolved) {
        isResolved = true;
        clearInterval(pollInterval); // Stop polling when event fires
        releaseEvents();
      }
    };

    // This event fires when OneTrust is fully loaded
    window.addEventListener("OneTrustGroupsUpdated", onConsentReady, {
      once: true,
    });
  };

  //===============
  //   Execution
  //===============

  // Always listen for consent changes
  if (!window.__OPTLY_LISTENER_ATTACHED__) {
    window.addEventListener("OTConsentApplied", releaseEvents);
    window.__OPTLY_LISTENER_ATTACHED__ = true;
  }

  waitForOneTrust();
}
